import React from 'react';
import { Activity, Building2, Users2, Sparkles, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const PILLARS = [
  {
    id: 'innovpulse',
    name: 'InnovPulse',
    tag: 'Intelligence & Decision',
    desc: 'InnovPulse provides the intelligence to see and decide better.',
    icon: Activity,
    link: '/innovpulse',
  },
  {
    id: 'studio-i',
    name: 'Studio I',
    tag: 'Environment & Proximity',
    desc: 'Studio I creates the space for ideas and opportunities to meet.',
    icon: Building2,
    link: '/studio-i',
  },
  {
    id: 'the-people',
    name: 'The People',
    tag: 'Human Expertise & Network',
    desc: 'The People bring in the experience, perspective and relationships that help ventures move forward.',
    icon: Users2,
    link: '/innovz',
  },
];

export default function MoreThanPrograms() {
  return (
    <section id="more-than-programs" className="relative bg-[#08080a] py-20 lg:py-28 border-t border-white/5 overflow-hidden">
      {/* Ambient pink glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[640px] h-[640px] rounded-full bg-[#d42b92]/10 blur-[160px] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-3xl reveal-up">
          <div className="text-[#ff8ec5] text-xs font-semibold tracking-[0.25em] uppercase mb-4 flex items-center gap-2">
            {/* <Sparkles className="w-3.5 h-3.5 text-[#ff8ec5]" /> */}
            Enabling Ecosystem
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-white leading-[1.12]">
            BUILT ON MORE THAN <br className="hidden sm:inline" />
            <span className="text-[#d42b92]">just PROGRAMS.</span>
          </h2>
          <p className="mt-6 text-white/80 text-base sm:text-lg lg:text-xl leading-relaxed">
            Great ventures are rarely built by programs alone. They grow through access to the right intelligence, the right environment and, most importantly, the right people.
          </p>
          <p className="mt-4 text-white/55 text-sm sm:text-base leading-relaxed">
            Behind InnovHer’s venture-building platforms is an enabling ecosystem designed to bring these forces together.
          </p>
        </div>

        {/* 3 Pillar Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mt-12 sm:mt-16">
          {PILLARS.map((pillar, idx) => {
            const Icon = pillar.icon;
            return (
              <div
                key={pillar.id}
                className="reveal-up group rounded-3xl border border-white/10 bg-white/[0.02] p-8 lg:p-9 hover:border-[#d42b92]/60 hover:bg-white/[0.04] transition-all duration-300 flex flex-col justify-between shadow-xl"
                style={{ transitionDelay: `${idx * 80}ms` }}
              >
                <div>
                  <div className="w-14 h-14 rounded-2xl bg-[#d42b92]/15 border border-[#d42b92]/30 grid place-items-center mb-6 group-hover:scale-105 group-hover:bg-[#d42b92]/25 transition-all">
                    <Icon className="w-6 h-6 text-[#ff8ec5]" />
                  </div>
                  <div className="text-[#ff8ec5] text-xs uppercase tracking-wider font-semibold mb-2">
                    {pillar.tag}
                  </div>
                  <h3 className="text-2xl font-bold text-white tracking-tight group-hover:text-[#ff8ec5] transition-colors">
                    {pillar.name}
                  </h3>
                  <p className="mt-4 text-white/65 text-base sm:text-lg leading-relaxed">
                    {pillar.desc}
                  </p>
                </div>

                <div className="mt-8 pt-6 border-t border-white/5 flex items-center justify-between text-sm font-semibold text-white/60 group-hover:text-white transition-colors">
                  <Link to={pillar.link} className="inline-flex items-center gap-2 group-hover:text-[#ff8ec5] transition-colors">
                    <span>Explore {pillar.name}</span>
                    <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                  </Link>
                </div>
              </div>
            );
          })}
        </div>

        {/* Closing Ecosystem Synthesis Card */}
        <div className="reveal-up mt-12 sm:mt-14 rounded-3xl border border-white/10 bg-gradient-to-r from-[#d42b92]/15 via-white/[0.02] to-transparent p-8 sm:p-10 lg:p-12 shadow-2xl relative overflow-hidden">
          <div className="max-w-4xl">
            <div className="text-xs uppercase tracking-[0.25em] text-[#ff8ec5] font-semibold mb-3">
              The Ecosystem Advantage
            </div>
            <p className="text-white/90 text-lg sm:text-xl lg:text-2xl font-medium leading-relaxed">
              Together, technology, proximity and human expertise create something more valuable than individual resources: <span className="text-white font-bold decoration-2 underline-offset-4">an ecosystem that learns,connects and grows with every venture it builds.</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
